import dayjs from "dayjs";

import { HOUR, MINUTE } from "@shared/constants";
import { OrgData, Repo, RepoScan, ScanStatus } from "@shared/types";

const SCAN_STARTING_WINDOW_MS = MINUTE * 5;
const SCAN_TIMEOUT_MS = HOUR * 1;
const SCAN_TIMEOUT_PRO_ENGINE_MS = HOUR * 4;
/**
 * Returns the current "status" of the scan.
 * @param scan the scan to categorize
 * @return the current status of the scan as a ScanStatus
 */
export const getScanStatus = (
  repo: Repo,
  scan: RepoScan | null,
  org: OrgData | undefined
): ScanStatus => {
  const provisionTime = dayjs(repo.provisioned_at!).toDate();
  const now = new Date();
  const timeout = org?.has_deepsemgrep
    ? SCAN_TIMEOUT_PRO_ENGINE_MS
    : SCAN_TIMEOUT_MS;

  if (scan === null) {
    if (now.getTime() - provisionTime.getTime() < SCAN_STARTING_WINDOW_MS) {
      return "starting";
    }
    return "never_started";
  } else if (scan.completed_at) {
    if (scan.exit_code === 0 || scan.exit_code === 1) {
      return "succeeded";
    } else {
      return "error";
    }
  } else if (scan.started_at) {
    const startedTime = dayjs(scan.started_at!).toDate();
    if (now.getTime() - startedTime.getTime() < timeout) {
      return "running";
    } else {
      return "never_finished";
    }
  } else {
    return "never_started";
  }
};
